import { Col, Row, Card } from "react-bootstrap";
import { useParams } from "react-router-dom";

import classes from "./createReturn.module.scss";
import { CreateReturnTableDetail } from "./CreateReturnTableDetail";
import CreateReturnTableHead from "./CreateReturnTableHead";

import Fetching from "@/components/Fetching/Fetching";

const CreateReturnTable = ({ data, setData, activeProduct, setActiveProduct, items, isFetchingTable, setOpenSearch }) => {
	const { option } = useParams();

	const handleAddItem = () => {
		let newDetails = [...data.details];
		newDetails.push({
			container_content: "",
			container_quantity: "",
			ids: "",
			inventory_id: "",
			orders_sale_id: "",
			orders_delivery_id: "",
			label: "",
			product_id: "",
			price: "",
			tradename: "",
			unit_measurement: "",
			value: "",
			value_column: "",
			name_column: "",
		});

		setData({ ...data, details: newDetails });
	};

	return (
		<Col md={12} className={classes.col_base}>
			<Card className={activeProduct && "active"}>
				<Card.Header onClick={() => setActiveProduct(!activeProduct)} className={activeProduct && "active"}>
					Productos
				</Card.Header>

				{activeProduct && (
					<>
						<Card.Body>
							<CreateReturnTableHead />
							<Row className={classes.body_table}>
								<Col md={12} sm={12}>
									{isFetchingTable ? <Fetching topMargin={"2em"} /> : <CreateReturnTableDetail data={data} setData={setData} items={items} />}
								</Col>
							</Row>
						</Card.Body>
						{option === "ingresar" && (
							<Card.Footer>
								<div className={classes.button_footer}>
									{data.type_document && (
										<div className={classes.button_action} onClick={() => handleAddItem()}>
											Agregar Producto
										</div>
									)}

									<div className={classes.button_action} onClick={() => setOpenSearch(true)}>
										Buscar Código
									</div>
								</div>
							</Card.Footer>
						)}
					</>
				)}
			</Card>
		</Col>
	);
};

export default CreateReturnTable;
